import { type Alphabet, HANGUL, choOf } from './alphabet';
import type { Question } from './pack';
import type { EngineRules } from './rules';

/**
 * 분노 게이지 (RULES §1.16 · ADR-020/035). 전부 wordTick 의 순수 함수 — 상태를 바꾸지 않는다.
 * 힌트 단위: 추론형 팩은 hints[1], hints[2] → 초성 / 아재개그는 초성만. 초성은 정답 길이 − 1 까지.
 */
export function angerStage(wordTick: number, r: EngineRules): number {
  if (!r.hintEnabled) return 0;
  let k = 0;
  for (const t of r.angerStageTicks) if (wordTick >= t) k++;
  return k;
}

/** 실효 틱 간격 배수 — 단계당 ANGER_SPEED_STEP_PCT %. 페널티 배수와 곱한다. */
export function angerSpeedDivisor(stage: number, r: EngineRules): number {
  return 1 + (r.angerSpeedStepPct * stage) / 100;
}

export { choOf };

export interface HintReveal {
  /** 항상 보이는 hints[0] 을 포함해 지금까지 열린 연상 힌트 */
  readonly assoc: readonly string[];
  /** 정답 슬롯별 초성(닫혀 있으면 null). 길이 = 정답 길이 */
  readonly cho: readonly (string | null)[];
  readonly stage: number;
  readonly maxStage: number; // 더 열릴 단위가 없으면 stage === maxStage
}

/** 총 힌트 단위 수 — 이 값에 도달하면 더 붉어져도 새 정보는 없다 */
export function hintUnits(q: Question): number {
  const assoc = q.hints === undefined ? 0 : Math.max(0, q.hints.length - 1);
  return assoc + Math.max(0, q.a.length - 1);
}

export function revealHints(q: Question, stage: number, alphabet: Alphabet = HANGUL): HintReveal {
  const hints = q.hints ?? [];
  const assocExtra = Math.max(0, hints.length - 1);
  const units = Math.min(stage, hintUnits(q));
  const assocShown = Math.min(units, assocExtra);
  const choShown = Math.min(Math.max(0, units - assocExtra), Math.max(0, q.a.length - 1));
  const assoc = hints.length > 0 ? hints.slice(0, 1 + assocShown) : [];
  const cho: (string | null)[] = [];
  for (let k = 0; k < q.a.length; k++) cho.push(k < choShown ? alphabet.hint(q.a.charAt(k)) : null);
  return { assoc, cho, stage: units, maxStage: hintUnits(q) };
}
